"use client"

import { useState, useEffect, useRef } from "react"
import { ChevronDown } from "lucide-react"

const CustomSelect = ({ options, value, onChange, placeholder = "Seleccionar" }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState(null)
  const selectRef = useRef(null)

  // Encuentra la opción seleccionada basada en el valor
  useEffect(() => {
    const option = options.find((opt) => opt.value === value)
    setSelectedOption(option || null)
  }, [value, options])

  // Cierra el dropdown cuando se hace clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  const handleOptionClick = (option) => {
    setSelectedOption(option)
    setIsOpen(false)
    if (onChange) {
      onChange({ target: { value: option.value } })
    }
  }

  return (
    <div className={`custom-select-wrapper ${isOpen ? "open" : ""}`} ref={selectRef}>
      <div className="custom-select-trigger" onClick={toggleDropdown}>
        <span>{selectedOption ? selectedOption.label : placeholder}</span>
        <ChevronDown size={16} className="custom-select-arrow" />
      </div>

      <div className="custom-select-options">
        {options.map((option) => (
          <div
            key={option.value}
            className={`custom-option ${selectedOption && selectedOption.value === option.value ? "selected" : ""}`}
            onClick={() => handleOptionClick(option)}
          >
            {option.label}
          </div>
        ))}
      </div>
    </div>
  )
}

export default CustomSelect

